// extracted by mini-css-extract-plugin
module.exports = {"className":"th-TH_className__H_lUY"};